import { lazyMountAndShowPhotoPickerDialog } from 'owa-photo-picker-dialog';

export default async function changePhotoRouteHandler() {
    await lazyMountAndShowPhotoPickerDialog.importAndExecute();
}
